import { useMemo, useState } from "react";
import { FieldValues, UseFormReturn } from "react-hook-form";
import styled from "styled-components";
import { z } from "zod";
import { Button } from "../../atoms/Button";
import { Input } from "../../atoms/Input";
import FormTemplate from "../../templates/FormTemplate";

type Props = {
  handleSubmit: (email: string, onError: (message: string) => void) => void;
};

export const LoginEmailForm: React.FC<Props> = ({ handleSubmit }) => {
  const [hasEmailError, setHasEmailError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>();

  const schema = useMemo(() => {
    return z.object({
      email: z.string().min(1),
    });
  }, []);

  const [methods, setMethods] = useState<UseFormReturn<
    FieldValues,
    unknown,
    FieldValues
  > | null>(null);

  return (
    <FormTemplate
      schema={schema}
      setMethods={setMethods}
      defaultValues={{ email: "" }}
      onSubmit={({ email }) => {
        handleSubmit(email, (message) => {
          setHasEmailError(true);
          setErrorMessage(message);
        });
      }}
    >
      <StyledTextContainer>
        メールアドレスを入力してください。
      </StyledTextContainer>

      <Input
        label="メールアドレス"
        name="email"
        type="email"
        autoComplete="email"
        autoFocus
        hasError={hasEmailError}
        errorMessage={errorMessage}
      />

      <StyledFooter>
        <Button variant="filled" text="次へ" type="submit" fullWidth />
      </StyledFooter>
    </FormTemplate>
  );
};

const StyledTextContainer = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 24px;
`;

const StyledFooter = styled.div`
  margin-top: 32px;
`;
